import { DialogContextType } from "@/lib/main";
import { createContext } from "react";

const DialogContext = createContext<DialogContextType | null>(null);

export default DialogContext;
